import React from 'react';
import PropTypes from 'prop-types';
import { IonButton, IonList, IonText, IonIcon } from '@ionic/react';
import { receiptOutline } from 'ionicons/icons';

function TableWarning({ onClose }) {
  return (
    <IonList className="ion-padding">
      <IonText className="center-flex-content mt-3x mb-5x">
        <IonIcon color="success" className="large-icon" icon={receiptOutline} />

        <h2 className="mt-3x">Your server split your check</h2>
        <p>
          Please select your check on the next screen based on the items you
          ordered.
        </p>
      </IonText>
      <div className="mt-3x">
        <IonButton
          color="secondary"
          expand="block"
          fill="solid"
          onClick={onClose}
        >
          Got it
        </IonButton>
      </div>
    </IonList>
  );
}

TableWarning.propTypes = {
  onClose: PropTypes.func,
};

export default TableWarning;
